/**
 * Shown in place of the globe when the deployment has no Cesium Ion token.
 *
 * The other routes work without it; this one cannot draw. The token is the
 * owner's to set, at /admin — a visitor can do nothing about it, so this says
 * what is wrong and who can fix it rather than offering a form.
 */

const code: React.CSSProperties = {
  fontFamily: "var(--font-data)",
  fontSize: 13,
  color: "var(--color-text-hi)",
  background: "var(--color-bg-2)",
  padding: "2px 6px",
  borderRadius: 4,
};

export function GlobeSetupNotice() {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "grid",
        placeItems: "center",
        background: "radial-gradient(ellipse at center, hsl(220 25% 6%) 0%, hsl(220 30% 2%) 70%)",
        padding: 24,
        pointerEvents: "auto",
      }}
    >
      <div
        className="glass"
        style={{
          maxWidth: 560,
          padding: 32,
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-elevated)",
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-data)",
            fontSize: 11,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
            color: "var(--color-ember-400)",
            marginBottom: 12,
          }}
        >
          One key to add
        </div>
        <h1
          style={{
            fontFamily: "var(--font-display)",
            fontSize: 32,
            fontWeight: 700,
            letterSpacing: "-0.03em",
            margin: 0,
            color: "var(--color-text-hi)",
          }}
        >
          The globe needs a Cesium Ion token
        </h1>
        <p
          style={{
            fontFamily: "var(--font-body)",
            fontSize: 15,
            lineHeight: 1.55,
            color: "var(--color-text-mid)",
            marginTop: 16,
          }}
        >
          World terrain and aerial imagery stream from Cesium Ion, which needs an access token. This
          deployment does not have one yet. Its owner can add it under{" "}
          <span style={code}>API keys</span> in the admin panel, and the globe appears for everyone
          at once. Every other page works without it.
        </p>
        <div style={{ display: "flex", gap: 12, marginTop: 24, flexWrap: "wrap" }}>
          <a
            href="https://ion.cesium.com/tokens"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-block",
              padding: "10px 18px",
              border: "1px solid var(--color-stroke-strong)",
              color: "var(--color-text-mid)",
              fontFamily: "var(--font-data)",
              fontSize: 12,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              textDecoration: "none",
              borderRadius: "var(--radius-md)",
            }}
          >
            Get a token ↗
          </a>
        </div>
      </div>
    </div>
  );
}
